import script from "./ProfessionalDevelopmentLessonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalDevelopmentLessonCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalDevelopmentLessonCard.vue?vue&type=style&index=0&id=4cba837d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cba837d"]])

export default __exports__